import React from 'react';
import { Route, Routes } from 'react-router-dom';

import HeaderSecondary from '@components/HeaderSecondary';

import CarQuoteBuyEditPage from './CarQuoteBuyEditPage';
import CarQuoteBuyNewPage from './CarQuoteBuyNewPage';
import CarQuoteBuyReviewPage from './CarQuoteBuyReviewPage';
import CarQuoteBuyResetPage from './CarQuoteBuyResetPage';
import CarQuoteBuyCustomPage from './CarQuoteBuyCustomPage';
import CarQuoteBuyLockPage from './CarQuoteBuyLockPage';
import CarQuoteBuyPayByCashPage from './CarQuoteBuyPayByCashPage';

const CarQuoteBuyRoute = () => {
  return (
    <>
      <HeaderSecondary />
      <Routes>
        <Route index element={<CarQuoteBuyNewPage />} />
        <Route path="/:orderNumber/edit" element={<CarQuoteBuyEditPage />} />
        <Route path="/:orderNumber/review" element={<CarQuoteBuyReviewPage />} />
        <Route path="/:orderNumber/reset" element={<CarQuoteBuyResetPage />} />
        <Route path="/:orderNumber/custom" element={<CarQuoteBuyCustomPage />} />
        <Route path="/:orderNumber/lock" element={<CarQuoteBuyLockPage />} />
        <Route path="/:orderNumber/pay-by-cash" element={<CarQuoteBuyPayByCashPage />} />
      </Routes>
    </>
  );
};

export { CarQuoteBuyRoute };
